<section class="search">
    <input [class.hasButton]="hasButton" [(ngModel)]="word" (keyup)="searchWord()" class="search--input" type="text" placeholder="Buscar produtos e serviços...">
    <button class="search--button" *ngIf="hasButton"
    routerLink="/products"
    [queryParams]="{ textSearch: word, categoryId: selectedCategory?.id, city: selectedLocation }">
        <app-icon src="/assets/icons/search.svg"></app-icon>
    </button>
</section>
